import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { CameraLayoutMode } from "@client/lib/foscam/cameraLayout";

interface UIStore {
  // Top bar
  chartLock: boolean;
  /** Rozložení mřížky kamer — volba uživatele, přežívá refresh. */
  foscamLayout: CameraLayoutMode;
  settingsOpen: boolean;
  mobileMenuOpen: boolean;
  // Edit mode (layout editor)
  editMode: boolean;
  // Dev message / banner (původně v UserContext)
  devMessage: string;

  toggleChartLock: () => void;
  toggleFoscamLayout: () => void;
  setSettingsOpen: (v: boolean) => void;
  setMobileMenuOpen: (v: boolean) => void;
  setEditMode: (v: boolean) => void;
  setDevMessage: (m: string) => void;
}

export const useUIStore = create<UIStore>()(
  persist(
    (set) => ({
      chartLock: false,
      foscamLayout: "auto",
      settingsOpen: false,
      mobileMenuOpen: false,
      editMode: false,
      devMessage: "",

      toggleChartLock: () => set((s) => ({ chartLock: !s.chartLock })),
      toggleFoscamLayout: () => set((s) => ({ foscamLayout: s.foscamLayout === "quad" ? "auto" : "quad" })),
      setSettingsOpen: (v) => set({ settingsOpen: v }),
      setMobileMenuOpen: (v) => set({ mobileMenuOpen: v }),
      setEditMode: (v) => set({ editMode: v }),
      setDevMessage: (m) => set({ devMessage: m }),
    }),
    {
      name: "demirel-ui",
      // Persist JEN user preferences, ne ephemeral state (settingsOpen, devMessage…).
      partialize: (s) => ({ chartLock: s.chartLock, foscamLayout: s.foscamLayout }),
    }
  )
);
